<div id="chart-{{graph.code}}" class="table-container">
    <aside class="locked">
        <table>
            <thead>
                <tr>
                    <th>{{graph.label}}</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let label of labels" class="deep-0">
                    <td>{{label}}</td>
                </tr>
            </tbody>
        </table>
    </aside>
    <section class="years-data">
        <table>
            <thead>
                <tr>
                    <th>{{graph.unit}}</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let value of values" class="deep-0">
                    <td>{{value}}</td>
                </tr>
            </tbody>
        </table>
    </section>
</div>
